import React from "react";

export const diccionarioDeLasHadasPublishedAt = (
  <span className="white">
    Revista <i>Vida</i>, No. 60, 1953-1954
  </span>
);
